<template>
	<div class="pre-money-wrap">
		<p class="title">诚意金</p>
		<div class="money-list">
			<ul>
				<li :class="{'active':item==choosedMoney}" @click="chooseMoney(item)" v-for="item in moneyList">{{item}}鱼币</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:"pre-money",
		data(){
			return{
				moneyList:[10,20,50,80,100,200],
				choosedMoney:""
			}
		},
		created(){
			
		},
		methods:{
			chooseMoney(money){
				this.choosedMoney = money;
				this.$emit("chooseMoney",this.choosedMoney);
			}
		}
	}
</script>

<style scoped>
	.pre-money-wrap{
		padding: 0.5rem 1rem 0;
	}
	.pre-money-wrap .title{
		background: url(../../assets/img/finds/ic_list_tab@2x.png) no-repeat left center;
	    background-size: contain;
	    padding-left: 1.6rem;
	    font-size: 1rem;
	    color: #282828;
	    font-weight: bold;
	    line-height: 1.5rem;
	    margin: 0.5rem 0;
	}
	.pre-money-wrap ul{
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
	}
	.pre-money-wrap li{
		width: 28%;
		text-align: center;
		background: #ededed;
		border: 1px solid #ededed;
		margin: 0.5rem 0;
		color: #626262;
		padding: 0.5rem 0;
		border-radius: 3rem;
		font-size: 0.8rem;
	}
	.pre-money-wrap li.active{
		background: #ddd0fe;
		border: 1px solid #753cff;
		color: #753cff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/PreMoney.vue